import {Injectable} from '@angular/core';
import {BaseService} from '../base.service';
import {IResourceMethod, ResourceAction, ResourceParams, ResourceRequestMethod} from '@ngx-resource/core';

/**
 Class for the CitiesService.
 */

export interface IStates {
    id?: number;
    title?: string;
    letter?: string;
    iso?: number;
    slug?: string;
    population?: number;
}

@Injectable()
@ResourceParams({
    url: BaseService.BASE_URL + '/v1/states'
})
export class CitiesService extends BaseService {

    @ResourceAction({
        path: '/panel-cities'
    })
    get: IResourceMethod<any, any>;

}



// WEBPACK FOOTER //
// ./src/app/core/api/cities/client.service.ts